import React, { useState } from "react";
import { Link } from "react-router-dom";

const MenuItems = (props) => {
  const { mobileMenu } = props;
  const [home, setHome] = useState(false);
  const [course, setCourse] = useState(false);
  const [page, setPage] = useState(false);
  const [blog, setBlog] = useState(false);
  const [membership, setMembership] = useState(false);
  const [studentcorner, setStudentcorner] = useState(false);

  const openMobileMenu = (menu) => {
    if (menu === "home") {
      setHome(!home);
      setCourse(false);
      setPage(false);
      setBlog(false);
      setMembership(false);
      setStudentcorner(false);
    } else if (menu === "course") {
      setHome(false);
      setCourse(!course);
      setPage(false);
      setBlog(false);
      setMembership(false);
      setStudentcorner(false);
    } else if (menu === "page") {
      setHome(false);
      setCourse(false);
      setPage(!page);
      setBlog(false);
      setMembership(false);
      setStudentcorner(false);
    } else if (menu === "blog") {
      setHome(false);
      setCourse(false);
      setPage(false);
      setBlog(!blog);
      setMembership(false);
      setStudentcorner(false);
    } else if (menu === "membership") {
      setHome(false);
      setCourse(false);
      setPage(false);
      setBlog(false);
      setMembership(!membership);
      setStudentcorner(false);
    } else if (menu === "studentcorner") {
      setHome(false);
      setCourse(false);
      setPage(false);
      setBlog(false);
      setMembership(false);
      setStudentcorner(!studentcorner);
    }
  };

  const handleClick = (e) => {
    if (mobileMenu) {
      e.preventDefault();
    }
  };

  return (
    <ul>
      <li className="has-dropdown p-static">
        <Link to="/">
          <span>Home</span>
        </Link>
      </li>
      <li className="has-dropdown">
        <Link to="/" className={course ? "expanded" : ""} onClick={handleClick}>
          <span>About</span>
          <button
            className={`${
              course
                ? "dropdown-toggle-btn dropdown-opened"
                : "dropdown-toggle-btn"
            } d-xl-none`}
            onClick={() => {
              openMobileMenu("course");
            }}
          >
            <i className="fal fa-angle-right"></i>
          </button>
        </Link>
        <ul
          className={
            course ? "it-submenu submenu d-block" : "it-submenu submenu"
          }
        >
          <li>
            <Link to="/mission">Mission</Link>
          </li>
          <li>
            <Link to="/strategic-partners">Strategic Partners</Link>
          </li>
          <li>
            <Link to="/leadership">Leadership</Link>
          </li>
        </ul>
      </li>
      <li className="has-dropdown">
        <Link
          to="/"
          className={membership ? "expanded" : ""}
          onClick={handleClick}
        >
          <span>Membership</span>
          <button
            className={`${
              membership
                ? "dropdown-toggle-btn dropdown-opened"
                : "dropdown-toggle-btn"
            } d-xl-none`}
            onClick={() => {
              openMobileMenu("membership");
            }}
          >
            <i className="fal fa-angle-right"></i>
          </button>
        </Link>
        <ul
          className={
            membership ? "it-submenu submenu d-block" : "it-submenu submenu"
          }
        >
          <li>
            <Link to="/membership">Registration</Link>
          </li>
          <li>
            <Link to="/all-members">Members</Link>
          </li>
        </ul>
      </li>
      <li>
        <Link to="/news">
          <span>News</span>
        </Link>
      </li>
      <li>
        <Link to="/event">
          <span>Events</span>
        </Link>
      </li>
      <li className="d-block d-md-none">
        <Link to="/jobs">
          <span>Jobs</span>
        </Link>
      </li>
      <li className="d-block d-md-none">
        <Link to="/education">
          <span>Education</span>
        </Link>
      </li>
      <li>
        <Link to="/contact">
          <span>Contact</span>
        </Link>
      </li>
      <li className="has-dropdown">
        <Link
          to="/"
          className={studentcorner ? "expanded" : ""}
          onClick={handleClick}
        >
          <span>Student’s Corner</span>
          <button
            className={`${
              studentcorner
                ? "dropdown-toggle-btn dropdown-opened"
                : "dropdown-toggle-btn"
            } d-xl-none`}
            onClick={() => {
              openMobileMenu("studentcorner");
            }}
          >
            <i className="fal fa-angle-right"></i>
          </button>
        </Link>
        <ul
          className={
            studentcorner ? "it-submenu submenu d-block" : "it-submenu submenu"
          }
        >
          <li>
            <Link to="/jobs">Jobs</Link>
          </li>
          <li>
            <Link to="/education">Education</Link>
          </li>
          <li>
            <Link to="/student-login">Login</Link>
          </li>
        </ul>
      </li>
      <li>
        <Link to="/announcement">
          <span>Announcement</span>
        </Link>
      </li>
    </ul>
  );
};

export default MenuItems;
